import { makeStyles, alpha } from '@material-ui/core';
import commonStyles from 'config/commonStyles';
import { theme } from 'config/theme';

export const useStyles = makeStyles({
    ...commonStyles,
    contactJamesTeamContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '80vh',
        textAlign: 'center',
        '& h1': {
            fontSize: '24px',
            lineHeight: '36px',
            color: '#5B5858',
        },
        '& h3': {
            width: 650,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#5B5858',
            marginTop: 0,
            fontWeight: 400,
        },
    },
});
